(() => {
  'use strict';

  const initializedHeaders = new WeakSet();
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

  const setDetailsState = (details, open) => {
    const summary = details.querySelector(':scope > summary');

    details.toggleAttribute('open', open);
    summary?.setAttribute('aria-expanded', String(open));
  };

  const closeSiblingMenus = (currentDetails) => {
    currentDetails
      .closest('.header__inline-menu')
      ?.querySelectorAll('.mega-menu[open]')
      .forEach((details) => {
        if (details !== currentDetails) setDetailsState(details, false);
      });
  };

  const enhanceMegaMenu = (details) => {
    let closeTimer;
    const summary = details.querySelector(':scope > summary');

    const open = () => {
      if (!hoverQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeSiblingMenus(details);
      setDetailsState(details, true);
    };

    const close = () => {
      if (!hoverQuery.matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => setDetailsState(details, false), 140);
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
    details.addEventListener('focusin', () => window.clearTimeout(closeTimer));
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) close();
    });
    details.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || !details.open) return;
      setDetailsState(details, false);
      summary?.focus();
    });
  };

  const enhanceDrawerSearch = (header) => {
    header.querySelectorAll('[data-fashion-search-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const drawerDetails = trigger.closest('header-drawer')?.querySelector(':scope > details');
        const searchSummary = header.querySelector('.header__icons .header__search summary');

        if (!searchSummary) return;
        drawerDetails?.querySelector(':scope > summary')?.click();
        window.setTimeout(() => searchSummary.click(), 180);
      });
    });
  };

  const enhanceDrawerState = (header) => {
    const drawerDetails = header.querySelector('header-drawer > details');
    if (!drawerDetails) return;

    const syncBodyState = () => {
      document.body.classList.toggle('fashion-drawer-open', drawerDetails.open);
    };

    drawerDetails.addEventListener('toggle', syncBodyState);
    syncBodyState();
  };

  const initializeHeader = (header) => {
    if (initializedHeaders.has(header)) return;
    initializedHeaders.add(header);

    header.querySelectorAll('.mega-menu').forEach(enhanceMegaMenu);
    enhanceDrawerSearch(header);
    enhanceDrawerState(header);
  };

  const initializeAllHeaders = (root = document) => {
    root.querySelectorAll('.fashion-header').forEach(initializeHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllHeaders(), { once: true });
  } else {
    initializeAllHeaders();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllHeaders(event.target));
})();
